import React from 'react'

export default function HomeIcon(props) {
  return (
    <svg viewBox='0 0 576 512' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='m476.9 499v-187.6c0-8.2 6.7-14.9 14.9-15l30.2-.1c12.7 0 19.5-14.8 11.4-24.5l-106.1-127-101.3-118.6c-14.3-16.7-40.2-16.7-54.4 0l-101.3 118.7-106.1 127c-8.1 9.7-1.2 24.5 11.4 24.5l30.2.1c8.2 0 14.9 6.7 14.9 15v187.5h112.9v-152.3h127.7v152.3z' />
    </svg>
  )
}
